import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'opm-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less'],
  standalone: false
})
export class HeaderComponent implements OnInit {
  isUserAuthorized: boolean = false;
  opmUpdatesAvailable: boolean = false;
  hideutility: boolean = false;
  showDqViolations: boolean = false;
  readOnlyAccessData: boolean = false;
  readWriteAccessData: boolean = false;

  constructor(
    private userService: UserService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.userService.getCurrentUserAsync().then(
      () => { this.isUserAuthorized = true; },
      () => { }
    );

    this.userService.getNewOpmUpdatesAvailable().then((response) => {
      this.opmUpdatesAvailable = response;
    });

    // Use Promise.all to wait for all access checks before evaluating visibility.
    // DQ Gate visibility uses its own dedicated group (DQGateGroupId) separate from utility RO/RW groups.
    Promise.all([
      this.userService.getReadOnlyAccessData(),
      this.userService.getWriteAccessData(),
      this.userService.getDQGateAccessData()
    ]).then(([readOnlyResponse, writeResponse, dqGateResponse]) => {
      this.readOnlyAccessData = readOnlyResponse;
      this.readWriteAccessData = writeResponse;

      const hasSupportAccess = this.readWriteAccessData || this.readOnlyAccessData;
      this.showDqViolations = dqGateResponse;

      // Utility + DQ Violations are support-team only (RO / RW AD groups).
      if (!hasSupportAccess) {
        this.hideutility = true;
        const url = this.router.url || '';
        const allowedWithoutSupport =
          url.startsWith('/basemappings') ||
          url.startsWith('/onboardedapps') ||
          url.startsWith('/containermappings');

        if (!allowedWithoutSupport) {
          this.router.navigate(['/containermappings']);
        }
      }
    });
  }

  bellIconClicked(): void {
    this.userService.resetNewOpmUpdatesAvailable();
    this.userService.bellIconClicked();
    this.opmUpdatesAvailable = false;
  }

  routeToContainerMapping() {
    this.router.navigate(['/containermappings']);
  }

  routeToDqViolations() {
    this.router.navigate(['/dq-gate']);
  }

  Homepage() {
    this.router.navigate(['/']);
  }
}
